import { render, staticRenderFns } from "./classificator-checkbox-input.vue?vue&type=template&id=c9a5ec22&scoped=true"
import script from "./classificator-checkbox-input.vue?vue&type=script&lang=js"
export * from "./classificator-checkbox-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a5ec22",
  null
  
)

export default component.exports